import { render, staticRenderFns } from "./vue-flow-editor-icon.vue?vue&type=template&id=1c0a149a&"
import script from "./vue-flow-editor-icon.vue?vue&type=script&lang=js&"
export * from "./vue-flow-editor-icon.vue?vue&type=script&lang=js&"
import style0 from "./vue-flow-editor-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports